import { render, staticRenderFns } from "./main.vue?vue&type=template&id=81d2133a&scoped=true"
import script from "./main.vue?vue&type=script&lang=js"
export * from "./main.vue?vue&type=script&lang=js"
import style0 from "./main.vue?vue&type=style&index=0&id=81d2133a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81d2133a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/Paldia/Paldia FE/FE-Paldia-Staging/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('81d2133a')) {
      api.createRecord('81d2133a', component.options)
    } else {
      api.reload('81d2133a', component.options)
    }
    module.hot.accept("./main.vue?vue&type=template&id=81d2133a&scoped=true", function () {
      api.rerender('81d2133a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/HTMLCodeEditor/main.vue"
export default component.exports